import { Pipe, PipeTransform } from '@angular/core';
import * as qs from 'qs';
import { NavigationItem, NavigationSubItem } from '../domain/entities/side-nav-items';

@Pipe({
  name: 'isNavMenuItemActive',
  standalone: true,
})
export class IsNavMenuItemActivePipe implements PipeTransform {
  transform(navItem: NavigationItem | NavigationSubItem, currentUrl: string): boolean {
    const link = !navItem.queryParams ? navItem.link : `${navItem.link}?${qs.stringify(navItem.queryParams)}`;

    if (link === currentUrl) {
      return true;
    }

    if (currentUrl.length > 1 && navItem.pathsInArea?.length) {
      return navItem.pathsInArea.some((p) => currentUrl.match(p)?.length);
    }

    return false;
  }
}
